import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../authorization.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(public authService:AuthorizationService) { }

  ngOnInit() {
    localStorage.setItem('loginit','false')
  }
  login(){
    this.authService.loginInit();
  }
}
